import { Resource } from '@prismamedia/one-crud-react';
import { BlocksConfig } from './blocks.config';

export const SectionsResource: Resource = {
  singular: 'section',
  plural: 'sections',
  basePath: 'sections',
  keyProperty: 'id',
  isRelationEnity: true,
  linkedResources: [
    {
      field: 'blocks',
      resource: BlocksConfig,
    },
  ],
};
